// @flow

import React, { useEffect } from 'react';
import _ from 'lodash';
import { RewriteFrames } from '@sentry/integrations';
import * as Sentry from '@sentry/browser';
import { version } from '../../../../package';

type Props = {
  children : any,
};

export default ({ children } : Props) => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      Sentry.init({
        dsn: process.env.SENTRY_DSN,
        release: version,
        environment: process.env.NODE_ENV,
        integrations: [new RewriteFrames()],
      });
      Sentry.configureScope((scope : any) => {
        const authenticationData = _.get(JSON.parse(localStorage.getItem('reduxState') || '{}'), ['Login', 'authenticationData']);
        if (authenticationData) {
          scope.setUser({
            username: _.get(authenticationData, 'username'),
          });
        }
        scope.setTag('LG_APP', _.get(window, ['webOS', 'platform', 'tv']) ? 'YES' : 'NO');
        scope.setExtra('SCREEN_SIZE', {
          view_size: {
            width: `${window.innerWidth}px`,
            height: `${window.innerHeight}px`,
          },
          screen_size: {
            width: `${window.screen.width}px`,
            height: `${window.screen.height}px`,
          },
        });
      });
    }
  }, []);

  try {
    return (
      <div>{children}</div>
    );
  } catch (error) {
    if (process.env.NODE_ENV === 'production') {
      Sentry.captureException(error);
    }
    return null;
  }
};
